<template>
  <status-chip
    v-if="isDisableDropdown"
    :label="statusLabel"
    :color="statusColor"
  >
  </status-chip>
  <vs-dropdown
    v-else
    :vsTriggerClick="vsTriggerClick"
    class="cursor-pointer"
    color="#2D9CDB"
  >
    <div class="status-chip " :style="{ background: statusColorHex }">
      <span class="aisea-text-12-700-white">{{ statusLabel }}</span>
      <feather-icon class="ml-1" icon="ChevronDownIcon" svgClasses="h-4 w-4" />
    </div>
    <vs-dropdown-menu>
      <vs-dropdown-item
        v-for="{ value, label } of statusLabelOptions"
        :key="value"
        @click="handleClickDropdownItem(value)"
        >{{ label }}</vs-dropdown-item
      >
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { ColorMixin } from "@/mixins";
import StatusChip from "../components/molecules/StatusChip.vue";
import { HULL_INSURANCE_CLAIM_TYPE_STATUS_LABEL } from "@/config/const";

export default {
  name: "O.ClaimTypeStatus",
  mixins: [ColorMixin],
  components: {
    StatusChip,
  },
  props: {
    status: {
      type: Number,
      required: true,
    },
    handleClickDropdownItem: {
      type: Function,
      default() {
        return;
      },
    },
    statusLabels: {
      type: Object, // Like HULL_INSURANCE_CLAIM_TYPE_STATUS_LABEL
      default() {
        return HULL_INSURANCE_CLAIM_TYPE_STATUS_LABEL;
      },
    },
    vsTriggerClick: {
      type: Boolean,
      default: true,
    },
    isDisableDropdown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    claimTypeStatusObject() {
      return HULL_INSURANCE_CLAIM_TYPE_STATUS_LABEL[this.status];
    },
    statusLabel() {
      if (!this.claimTypeStatusObject) return "";
      return this.claimTypeStatusObject.label;
    },
    statusColor() {
      if (!this.claimTypeStatusObject) return "";
      return `${this.claimTypeStatusObject.color}`;
    },
    statusColorHex() {
      if (this.statusColor.length === 0) return "";
      return `#${this.statusColor}`;
    },
    statusLabelOptions() {
      return Object.values(this.statusLabels)
        .filter(statusLabelObj => statusLabelObj.value !== this.status)
        .reduce((acc, statusLabelObj) => {
          acc[statusLabelObj.value] = statusLabelObj;
          return acc;
        }, {});
    },
  },

  methods: {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
.status-chip {
  min-width: 70px;
  max-width: 70px;
  height: 24px;
  border-radius: 6px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
